import { resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d89f074"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "icon icon-search"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-search", {'desktop--input-search': !_ctx.mainStore.isMobile}])
  }, [
    _createVNode(_component_el_input, _mergeProps(_ctx.$attrs, {
      class: "w-50 m-2",
      placeholder: _ctx.$attrs.placeholder || _ctx.$localize('home.placeholder.search'),
      enterkeyhint: "search",
      onKeyup: _withKeys(_ctx.onEnter, ["enter"])
    }), null, 16, ["placeholder", "onKeyup"]),
    (!_ctx.$attrs.modelValue)
      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
      : (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: "icon icon-closed",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear')))
        }))
  ], 2))
}